enum SitePermissionTypes {
  A = 'Administrator',
  U = 'User',
  G = 'Grant',
}

export default SitePermissionTypes;
